import { useAppTranslation } from "@/utils";
import { useNavigate } from "react-router-dom";
import { Button, Col, Drawer, Flex, Image, Page, Row, Typography, usePaypingContext } from "@payping/web-components";
import { Close } from "@payping/icons";
import { DashboardRoutes } from "@/router";
import { SubLayout } from "@/components/SubLayout";
import { closeId, ctaId } from "@/assets/googleTrackIds";
import { URLS } from "@payping/utilities-shared/consts";

const Fail = () => {
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const { breakpoints } = usePaypingContext();
  const { md } = breakpoints;
  return (
    <>
      <Drawer
        title={<Typography.Text>{t("digitalAccount.termsAndCondition.samanBankAccountOpeningForm")}</Typography.Text>}
        open={true}
        closable={false}
        size={"100%"}
        placement={"bottom"}
        extra={
          <Button
            type={"text"}
            icon={<Close width={14} height={14} />}
            onClick={() => {
              navigate(DashboardRoutes.digitalAccount.home?.url);
            }}
            data-google-track={closeId}
          />
        }
      >
        <Page>
          <SubLayout>
            <Flex vertical gap={32}>
              <div className="tw:flex! tw:justify-center!">
                <Image src={`${URLS.STORAGE_URL}/img/UnSuccesful.png`} preview={false} height={128} width={128} />
              </div>
              <Typography.Text className="tw:flex! tw:justify-center! tw:whitespace-pre-line">
                {t("digitalAccount.fail.failDesc")}
              </Typography.Text>
              {md ? (
                <Flex gap={16} className="tw:flex! tw:justify-center!">
                  <Button type={"default"}>{t("cancel")}</Button>
                  <Button type={"primary"} data-google-track={ctaId}>
                    {t("tryAgain")}
                  </Button>
                </Flex>
              ) : null}
            </Flex>
          </SubLayout>
        </Page>
      </Drawer>
      {!md ? (
        <Drawer open={true} closeIcon={false} mask={false} size={80} placement={"bottom"}>
          <Row gutter={16}>
            <Col flex={1}>
              <Button block type={"default"}>
                {t("cancel")}
              </Button>
            </Col>
            <Col flex={3}>
              <Button block type={"primary"} data-google-track={ctaId}>
                {t("tryAgain")}
              </Button>
            </Col>
          </Row>
        </Drawer>
      ) : null}
    </>
  );
};

export default Fail;
